
  export default {
    middleware: ['provider', 'products', 'blog/articles', 'breadcrumbs', 'jumbotron', 'meta-tags'],
    meta: {
      category: 'banking',
      isProviderPage: true,
      providerBreadcrumbs: [['i18n/home', '/'], ['i18n/banking', '/money/'], ['i18n/cards', '/compare-credit-cards/'],
                            ['i18n/providers', '/compare-credit-cards/providers/', 'mobile']],
      jumbotronScope: 'compare-credit-cards.provider',
      metaTagOptions: { image: 'cards' },
      product: 'cards',
      searchPath: 'banking/cards'
    },
    computed: {
      provider () {
        return this.$store.getters['providers/get'];
      }
    }
  };
